import Footer from "../Components/Footer";
import Header from "../Components/Header";

export default function SevaPrkalp() {
  return (
    <div>
      <Header />
      <main id="main" className="main min-height bg-bgWarm">
        <section className="px-3 pb-16">
          <div className="w-full border-b border-heads/20 mb-10 pt-6">
            <div className="mx-auto px-8">
              <div className="mb-6 text-3xl font-bold text-heads font-Philosopher text-center">
                <span>🌸 सेवा प्रकल्प 🌸</span>
              </div>
            </div>
          </div>

          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12 animate-fade-in">
            {/* Intro */}
            <div className="glassmorphism rounded-2xl p-8 text-center shadow-lg border-t-4 border-main">
              <h2 className="text-2xl font-bold text-accent mb-4 ">
                “सेवा ही साधना है, सेवा ही भक्ति है।”
              </h2>
              <p className="text-lg text-heads leading-relaxed mb-4">
                सनातन धर्म की महान परंपरा में सेवा को भगवान की आराधना का एक महत्वपूर्ण माध्यम माना गया है। इसी भावना से श्रीकृष्ण संकीर्तन के माध्यम से विभिन्न सेवा प्रकल्पों का संचालन एवं विस्तार करने का संकल्प लिया गया है।
              </p>
              <p className="text-lg text-heads leading-relaxed">
                हमारा उद्देश्य केवल धार्मिक कार्यक्रम करना ही नहीं, बल्कि भक्ति, सनातन संस्कृति, गौसेवा, अन्नसेवा एवं मंदिर सेवा के माध्यम से समाज में सेवा और संस्कार की भावना को बढ़ाना है।
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Project 1 */}
              <div className="glassmorphism rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 group">
                <div className="flex items-center mb-6">
                  <span className="text-4xl mr-4 group-hover:scale-110 transition-transform">🕉️</span>
                  <h3 className="text-2xl font-bold text-heads ">1. भक्ति एवं सनातन धर्म प्रचार-प्रसार</h3>
                </div>
                <p className="text-heads/80 mb-4 font-medium">भक्ति का प्रचार-प्रसार एवं सनातन धर्म की सेवा हमारे प्रमुख सेवा प्रकल्पों में से एक है। इसके अंतर्गत—</p>
                <ul className="space-y-2 text-heads/80 list-disc list-inside ml-2">
                  <li>श्रीहरिनाम संकीर्तन एवं सत्संग</li>
                  <li>श्रीमद्भगवद्गीता, रामायण एवं अन्य धार्मिक ग्रंथों का प्रचार</li>
                  <li>सनातन धर्म एवं हिंदू वैदिक संस्कृति का प्रचार-प्रसार</li>
                  <li>धार्मिक एवं आध्यात्मिक कार्यक्रमों का आयोजन</li>
                  <li>बच्चों एवं युवाओं में भारतीय संस्कार एवं संस्कृति के प्रति जागरूकता</li>
                  <li>समाज में भक्ति, सदाचार और सेवा की भावना का प्रसार</li>
                </ul>
                <p className="mt-4 font-semibold text-accent">हमारा प्रयास है कि सनातन की ज्ञान एवं भक्ति परंपरा अधिक से अधिक लोगों तक पहुँचे।</p>
              </div>

              {/* Project 2 */}
              <div className="glassmorphism rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 group">
                <div className="flex items-center mb-6">
                  <span className="text-4xl mr-4 group-hover:scale-110 transition-transform">🐄</span>
                  <h3 className="text-2xl font-bold text-heads ">2. गौ सेवा</h3>
                </div>
                <p className="text-accent font-semibold mb-4 italic">“गौ सेवा, सनातन संस्कृति की सेवा है।”</p>
                <p className="text-heads/80 mb-4 font-medium">गौमाता की सेवा एवं संरक्षण के लिए यथासंभव प्रयास किया जाएगा। इस सेवा के अंतर्गत—</p>
                <ul className="space-y-2 text-heads/80 list-disc list-inside ml-2">
                  <li>गौओं के लिए चारा एवं आहार की व्यवस्था</li>
                  <li>बीमार एवं असहाय गौओं की सेवा</li>
                  <li>गौशाला एवं गौ संरक्षण कार्यों में सहयोग</li>
                  <li>गौ सेवा के प्रति समाज में जागरूकता</li>
                </ul>
                <p className="mt-4 font-semibold text-accent">हमारा संकल्प है कि सामर्थ्य के अनुसार गौमाता की सेवा निरंतर जारी रहे।</p>
              </div>

              {/* Project 3 */}
              <div className="glassmorphism rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 group">
                <div className="flex items-center mb-6">
                  <span className="text-4xl mr-4 group-hover:scale-110 transition-transform">🍚</span>
                  <h3 className="text-2xl font-bold text-heads ">3. पार्वती रसोई — अन्न सेवा</h3>
                </div>
                <p className="text-accent font-semibold mb-4 italic">“कोई भूखा न सोए, यही अन्न सेवा का संकल्प है।”</p>
                <p className="text-heads/80 mb-4 font-medium">पार्वती रसोई के माध्यम से जरूरतमंद, भूखे एवं साधु-संतों के लिए भोजन एवं प्रसाद की व्यवस्था करने का प्रयास किया जाएगा। इस सेवा के अंतर्गत—</p>
                <ul className="space-y-2 text-heads/80 list-disc list-inside ml-2">
                  <li>जरूरतमंद एवं भूखे लोगों को भोजन/प्रसाद</li>
                  <li>साधु-संतों के लिए भोजन प्रसादी की व्यवस्था</li>
                  <li>धार्मिक आयोजनों में प्रसाद सेवा</li>
                  <li>सामर्थ्य के अनुसार नियमित अन्न सेवा</li>
                </ul>
                <p className="mt-4 font-semibold text-accent">अन्नदान को सनातन परंपरा में अत्यंत पुण्यकारी सेवा माना गया है। हमारा प्रयास है कि इस सेवा का विस्तार अधिक से अधिक जरूरतमंद लोगों तक हो।</p>
              </div>

              {/* Project 4 */}
              <div className="glassmorphism rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 group">
                <div className="flex items-center mb-6">
                  <span className="text-4xl mr-4 group-hover:scale-110 transition-transform">🧹</span>
                  <h3 className="text-2xl font-bold text-heads ">4. मंदिर स्वच्छता सेवा</h3>
                </div>
                <p className="text-accent font-semibold mb-4 italic">“स्वच्छ मंदिर — पवित्र वातावरण — निर्मल मन।”</p>
                <p className="text-heads/80 mb-4 font-medium">मंदिर केवल पूजा का स्थान नहीं, बल्कि हमारी आस्था और संस्कृति का केंद्र हैं। इसलिए मंदिरों की स्वच्छता एवं पवित्र वातावरण बनाए रखने के लिए श्रमदान एवं स्वच्छता सेवा का आयोजन किया जाएगा। इसके अंतर्गत—</p>
                <ul className="space-y-2 text-heads/80 list-disc list-inside ml-2">
                  <li>मंदिर परिसर की साफ-सफाई</li>
                  <li>मंदिर के आसपास के क्षेत्र की स्वच्छता</li>
                  <li>श्रमदान के माध्यम से स्वच्छता अभियान</li>
                  <li>भक्तों एवं युवाओं को सेवा के लिए प्रेरित करना</li>
                </ul>
                <p className="mt-4 font-semibold text-accent">हमारा संदेश है— “अपने मंदिर की सेवा, अपने हाथों से।”</p>
              </div>
            </div>

            {/* Outro */}
            <div className="bg-main text-white rounded-2xl p-10 text-center shadow-xl mt-12 bg-opacity-90">
              <h2 className="text-3xl font-bold mb-6 ">🙏 आपका सहयोग एवं शुभेच्छा</h2>
              <p className="text-lg leading-relaxed mb-6">
                इन सभी सेवा प्रकल्पों को निरंतर चलाने और अधिक से अधिक लोगों तक पहुँचाने के लिए आपके सहयोग, आशीर्वाद एवं शुभेच्छाओं की आवश्यकता है। आप स्वयं इन सेवाओं में सहभागी बन सकते हैं—
              </p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center font-bold text-xl mb-8">
                <div className="bg-white/20 py-3 px-4 rounded-lg">तन से<br/><span className="text-sm font-normal">श्रमदान द्वारा</span></div>
                <div className="bg-white/20 py-3 px-4 rounded-lg">मन से<br/><span className="text-sm font-normal">सेवा भावना द्वारा</span></div>
                <div className="bg-white/20 py-3 px-4 rounded-lg">धन से<br/><span className="text-sm font-normal">यथाशक्ति सहयोग द्वारा</span></div>
                <div className="bg-white/20 py-3 px-4 rounded-lg">समय से<br/><span className="text-sm font-normal">सेवा में सहभागिता द्वारा</span></div>
              </div>
              <p className="text-lg leading-relaxed mb-8 italic">
                आपका छोटा सा सहयोग भी किसी के लिए भोजन, किसी गौ के लिए चारा, किसी मंदिर के लिए स्वच्छता और किसी व्यक्ति के जीवन में भक्ति का प्रकाश बन सकता है।
              </p>
              
              <div className="border-t border-white/30 pt-8">
                <h3 className="text-2xl font-bold mb-4 ">🌺 आइए, सेवा से जुड़ें 🌺</h3>
                <ul className="inline-block text-left text-lg font-medium space-y-2">
                  <li>✓ भक्ति का प्रचार करें।</li>
                  <li>✓ सनातन संस्कृति को आगे बढ़ाएँ।</li>
                  <li>✓ गौमाता की सेवा करें।</li>
                  <li>✓ भूखे को भोजन कराएँ।</li>
                  <li>✓ अपने मंदिर को स्वच्छ रखें।</li>
                </ul>
                <p className="text-3xl font-bold mt-8 ">राधे राधे 🙏</p>
              </div>
            </div>

          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
